import { Suspense } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Outlet, useLocation } from 'react-router';

import useAccountQuery from 'api/queries/useAccountQuery';
import CartSheet from 'features/shop/cart/CartSheet';
import { AddToRecurringModal, setSuppressRecurringModal } from 'features/shop/recurringModals';
import Loader from 'honeydew/Loader';
import useGlobalStore from 'hooks/useGlobalStore';
import useTailwindTheme from 'hooks/useTailwindTheme';

function ProductDetailPageLayout() {
    const { data: account } = useAccountQuery();
    const { autocompleteOpen, recurringModal, searchQuery, setRecurringModal } = useGlobalStore();
    const location = useLocation();

    const tailwindTheme = useTailwindTheme();
    const mobile = useMediaQuery({ maxWidth: tailwindTheme?.screens?.md });
    const searchAutocompleteOpen = autocompleteOpen && searchQuery !== '';

    const handleCloseRecurringModal = (suppressFutureModals) => {
        if (suppressFutureModals) {
            setSuppressRecurringModal(true);
        }
        setRecurringModal({ open: false, itemName: '' });
    };

    if (!account?.nextOrder?.chargeID) {
        return (
            <div className="mt-[140px] flex justify-center">
                <Loader />
            </div>
        );
    }

    const productData = location?.state?.productData ?? null;

    return (
        <Suspense fallback={<Loader />}>
            {!mobile && !searchAutocompleteOpen && <CartSheet orderMinOnly />}
            <Outlet context={{ productData }} />
            <AddToRecurringModal
                isOpen={recurringModal.open}
                itemName={recurringModal.itemName}
                onClose={handleCloseRecurringModal}
            />
        </Suspense>
    );
}

export default ProductDetailPageLayout;
